import * as Yup from 'yup';
import {teamMemberPhoto} from '../../../../../../assets/symbols/images/teamMemberPhoto';
import {TLecturer} from '../../../../../../redux/timetable/timetable.type';

export type TabId = 'lecturer' | 'about';

export interface Values {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    country: string;
    image: string;
    about: string;
    link: string;
    liveLink: string;
}

export const valuesFromLecturer = (lecturer?: TLecturer): Values => ({
    firstName: lecturer?.firstName ?? '',
    lastName: lecturer?.lastName ?? '',
    email: lecturer?.email ?? '',
    phone: lecturer?.phone ?? '',
    country: '',
    image: lecturer?.image || teamMemberPhoto,
    about: '',
    link: '',
    liveLink: '',
});

export const initialValues: Values = valuesFromLecturer();

export const inputDefaults = {events: {}, className: '', forwardRef: null} as const;

export const buildSchema = (
    requiredMessage: string,
    nameTooShortMessage: string,
    nameTooLongMessage: string,
    phoneTooShortMessage: string,
    phoneTooLongMessage: string,
) =>
    Yup.object({
        firstName: Yup.string()
            .trim()
            .min(2, nameTooShortMessage)
            .max(20, nameTooLongMessage)
            .required(requiredMessage),
        lastName: Yup.string()
            .trim()
            .min(2, nameTooShortMessage)
            .max(20, nameTooLongMessage)
            .required(requiredMessage),
        email: Yup.string().trim().email(),
        phone: Yup.string()
            .trim()
            .matches(/^\d+$/, {excludeEmptyString: true})
            .min(7, phoneTooShortMessage)
            .max(15, phoneTooLongMessage),
    });
